<template>
  <!-- 방송 소프트웨어 아이콘: OBS ↔ PRISM 을 일정 간격으로 크로스페이드 -->
  <div class="bsw-icon" :style="{ width: `${size}px`, height: `${size}px` }">
    <div class="bsw-icon__layer bsw-obs" :class="{ 'is-on': !showPrism }"></div>
    <div class="bsw-icon__layer bsw-prism" :class="{ 'is-on': showPrism }"></div>
  </div>
</template>

<script>
export default {
  name: "VObsPrismIcon",
  props: {
    size: { type: [Number, String], default: 40 },
    interval: { type: Number, default: 3000 }, // 전환 간격(ms)
  },
  data: () => ({ showPrism: false }),
  mounted() {
    this._timer = setInterval(() => {
      this.showPrism = !this.showPrism;
    }, this.interval);
  },
  beforeDestroy() {
    clearInterval(this._timer);
  },
};
</script>

<style scoped>
.bsw-icon {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.bsw-icon__layer {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 0.7s ease;
}
.bsw-icon__layer.is-on {
  opacity: 1;
}
.bsw-obs {
  background-image: url("@/assets/obs_40.jpg");
}
.bsw-prism {
  background-image: url("@/assets/prism.webp");
}
</style>
